import qs from 'qs'
import type {SWRConfiguration} from 'swr'
import useSWR from 'swr'

import type {
    KycInformation,
    KycInformationName,
    KycInformationRequiredFor,
    KycInformationSubject,
    KycInformationType,
} from '@product-web/api-types/kyc-overview'
import {useUser} from '@product-web/user'

import {getDeimos} from '../helpers'

export interface KycInformationFilterOptions {
    name: KycInformationName
    type: KycInformationType
    subject: KycInformationSubject
    subjectId: string
    requiredFor: KycInformationRequiredFor
}

export const useMissingKycInformation = (
    filters?: Partial<KycInformationFilterOptions>,
    config?: SWRConfiguration,
    preventFetching = false,
) => {
    const user = useUser()
    const filtersWithFDDDefault = {requiredFor: 'FDD', ...filters}

    const params = qs.stringify(filtersWithFDDDefault, {addQueryPrefix: true})

    const {data, mutate, isValidating, error} = useSWR<KycInformation[]>(
        !preventFetching && user?.companyId
            ? `/rest/v1/reviews/companies/${user?.companyId}/missing-information${params}`
            : null,
        getDeimos,
        {refreshInterval: 0, revalidateOnFocus: false, ...config},
    )

    return {
        data,
        mutate,
        isValidating,
        error,
    }
}
